import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable()
export class RichTextDocumentService {
  // Observable string sources
  private fileuploadSource = new Subject<any>();
  private checkValidSource = new Subject<any>();
  private sheetToJsonDataSource = new BehaviorSubject([]);

  // Observable string streams
  public fileuploadDataobservable$ = this.fileuploadSource.asObservable();
  public checkValidDataobservable$ = this.checkValidSource.asObservable();
  public sheetToJsonDataobservable$ = this.sheetToJsonDataSource.asObservable();

  // Service message commands
  public sendFileUploadedData(d: any): void {
    this.fileuploadSource.next(d);
  }

  public sendIfValidData(d: any): void {
    this.checkValidSource.next(d);
  }

  public getSheetToJSONData(d: any): void {
    // console.log('file service json created.', d);
    this.sheetToJsonDataSource.next(d);
  }
}
